import * as React from 'react';
import { ISms, Recipients } from '../../../Types';
import * as userStore from '../../../../../../../shared/UserStore';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate } from '../../../../../../../shared/LanguageService';
import DateTimeView from '../../../../../../../features/localDate/DateTimeView';

interface IProps {
    item: ISms;
    key: number;
    onView: (smsId: number) => void;
}

const SmsListRow = (props: IProps) => {
    return (
        <tr>
            <td>
                {props.item.recipientType.value > 0 &&
                    Translate(props.item.recipientType.displayName)}
            </td>
            <td>
                <DateTimeView dateTime={props.item.createdTime} />
            </td>
            <td>
                <DateTimeView dateTime={props.item.sentTime} />
            </td>
            <td>
                <DateTimeView dateTime={props.item.failedTime} />
            </td>
            <td>
                <ButtonToolbar className="pull-right btn-group-sm">
                    <Button onClick={() => props.onView(props.item.id)} bsStyle="primary">
                        <i className="material-icons">edit</i>{' '}
                        {Translate(
                            'view-order/basic-order-info/modal/view-sms/button-labels/view-details'
                        )}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default SmsListRow;
